import {
  award_form_from_row,
  bid_form_from_row,
  deviation_form_from_row,
  irregularity_form_from_row,
  requisition_form_from_row
} from './procurement_form_state_helpers';

export function next_id(rows, prefix, pad = 0) {
  const number = rows.reduce((max, row) => Math.max(max, Number(String(row.id || '').replace(/[^\d]/g, ''))), 0) + 1;
  const suffix = pad ? String(number).padStart(pad, '0') : String(number);
  return `${prefix}${suffix}`;
}

export function status_class(label, success = 'Approved', warning = []) {
  if (label === success) return 'bg-success-subtle text-success-emphasis';
  if (warning.includes(label)) return 'bg-warning-subtle text-warning-emphasis';
  return 'bg-danger-subtle text-danger-emphasis';
}

function overview_overlay_open(context) {
  const is_open = context.category_modal_open || context.threshold_modal_open;
  return is_open;
}

function requisitions_overlay_open(context) {
  const is_open = context.requisition_modal_open || context.active_requisition_drawer;
  return is_open;
}

function bids_overlay_open(context) {
  const is_open = context.bid_modal_open || context.award_modal_open;
  return is_open;
}

export function active_procurement_overlay(context) {
  const overlay_state_map = {
    overview: overview_overlay_open(context),
    requisitions: requisitions_overlay_open(context),
    bids: bids_overlay_open(context),
    deviations: context.deviation_modal_open,
    irregularities: context.irregularity_modal_open
  };
  const overlay_state = Reflect.get(overlay_state_map, context.active_tab) || false;
  return overlay_state;
}

export function procurement_close_handler(context) {
  const close_handlers = [
    ['category_modal_open', context.close_category_modal],
    ['threshold_modal_open', context.close_threshold_modal],
    ['requisition_modal_open', context.close_requisition_modal],
    ['bid_modal_open', context.close_bid_modal],
    ['award_modal_open', context.close_award_modal],
    ['deviation_modal_open', context.close_deviation_modal],
    ['irregularity_modal_open', context.close_irregularity_modal]
  ];
  const matched_handler = close_handlers.find(([key]) => Reflect.get(context, key));
  return matched_handler ? matched_handler[1] : context.close_requisition_drawer;
}

export function modal_row_id(mode, edit_key, rows, prefix, pad = 0) {
  if (mode === 'edit') return edit_key;
  return next_id(rows, prefix, pad);
}

export function declarations_class(declarations, status) {
  const normalized_declarations = declarations.toLowerCase();
  if (normalized_declarations.includes('conflict')) return 'bg-warning-subtle text-warning-emphasis';
  if (normalized_declarations.includes('missing') || status === 'Rejected') return 'bg-danger-subtle text-danger-emphasis';
  return 'bg-success-subtle text-success-emphasis';
}

export function award_status_class(label) {
  if (label === 'Blocked') return 'bg-danger-subtle text-danger-emphasis';
  if (label === 'Pending') return 'bg-warning-subtle text-warning-emphasis';
  return 'bg-success-subtle text-success-emphasis';
}

export function replace_or_prepend(rows, edit_key, row_payload, is_edit) {
  if (!is_edit) return [row_payload, ...rows];
  return rows.map((row) => row.id === edit_key ? { ...row_payload, id: edit_key, highlighted: false } : row);
}

export {
  award_form_from_row,
  bid_form_from_row,
  deviation_form_from_row,
  irregularity_form_from_row,
  requisition_form_from_row
};
